import { LOADING } from "./types";
// Set Loading
export const setLoading = () => {
    return {
        type: LOADING
    };
}